import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import moment from 'moment';
import { downloadimage, eyeIc } from '../../components/imagepath';
import { CustomTable } from '../../components/Table';

import {
  FilesIconByType,
  ShowFileInTab,
  downloadFile,
} from '../../utils/functions';

/**
 * DocumentConsultationTables Component
 * 
 * Extracts document and consultation listing tables from the appointment details form.
 * Handles document management and consultation history display.
 * Maintains all existing table functionality and data display features.
 * Includes document upload/download features.
 * 
 * @param {Object} props - Component props
 * @param {Object} props.CcPaperDetail - Chief complaint paper details containing laboratoryDocs and consultation
 */
const DocumentConsultationTables = ({ CcPaperDetail }) => {
  return (
    <div className="row">
      {/* Document Section - Half Width */}
      <div className="col-md-6">
        <div className="card">
          <div className="card-body">
            <div className="mb-4 text-center">
              <h4 style={{ color: '#111827', fontWeight: '700', fontSize: '18px', display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'center' }}>
                <FeatherIcon icon="file" size="20" style={{ color: '#4f46e5' }} />
                Patient Documents
              </h4>
            </div>

            <CustomTable
              CurrentPageNum={1}
              TotalPageList={1}
              column={[
                {
                  title: 'File Name',
                  dataIndex: 'name',
                  render: (text, record) => {
                    const fileType = record.split('.').pop();
                    return (
                      <>
                        {FilesIconByType(fileType)}
                        <span className="mx-3">
                          {record.substring(record.lastIndexOf('/') + 1)}
                        </span>
                      </>
                    );
                  },
                },
                {
                  title: 'Action',
                  dataIndex: 'name',
                  render: (text, record) => {
                    const fileType = record.split('.').pop();
                    return (
                      <div
                        className="activity-boxs comman-flex-end "
                        style={{ background: 'none' }}
                      >
                        <img
                          src={downloadimage}
                          className="mx-2"
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            const url = process.env.REACT_APP_DOCS_URL + record;
                            downloadFile(url);
                          }}
                        />
                        <img
                          src={eyeIc}
                          className="mx-2"
                          style={{ cursor: 'context-menu' }}
                          onClick={() =>
                            ShowFileInTab(
                              record,
                              record.substring(record.lastIndexOf('/') + 1)
                            )
                          }
                        />
                      </div>
                    );
                  },
                },
              ]}
              dataSource={CcPaperDetail?.laboratoryDocs || []}
              dataSourceLength={5}
              pageSize={10}
              loader={false}
              ShowHeader={true}
              Header={<div className="staff-search-table"></div>}
              key={'MedicalDetail'}
            />
          </div>
        </div>
      </div>

      {/* Consultation Section - Half Width */}
      <div className="col-md-6">
        <div className="card">
          <div className="card-body">
            <div className="mb-4 text-center">
              <h4 style={{ color: '#111827', fontWeight: '700', fontSize: '18px', display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'center' }}>
                <FeatherIcon icon="message-square" size="20" style={{ color: '#4f46e5' }} />
                Consultation History
              </h4>
            </div>

            <CustomTable
              CurrentPageNum={1}
              TotalPageList={1}
              column={[
                {
                  title: 'Customer',
                  dataIndex: 'customerId',
                  render: (customer, record) => (
                    <Link
                      to={`/patient-list/appointment-details?consultationId=${record?._id}&page=1`}
                    >
                      {customer?.name || '---'}
                    </Link>
                  ),
                },
                {
                  title: 'Admin',
                  dataIndex: 'adminId',
                  render: admin => <span>{admin?.name || '---'}</span>,
                },
                {
                  title: 'Status',
                  dataIndex: 'status',
                  render: status => (
                    <span
                      style={{
                        padding: '4px 8px',
                        borderRadius: '4px',
                        background: status === 'Completed' ? '#d1fae5' : '#fee2e2',
                        color: status === 'Completed' ? '#065f46' : '#991b1b',
                        fontSize: '12px',
                        fontWeight: '500',
                      }}
                    >
                      {status || '---'}
                    </span>
                  ),
                },
                {
                  title: 'Created',
                  dataIndex: 'createdAt',
                  render: date => (
                    <span>{moment(date).format('DD/MM/YYYY') || '---'}</span>
                  ),
                },
              ]}
              dataSource={CcPaperDetail?.consultation || []}
              dataSourceLength={5}
              pageSize={10}
              loader={false}
              ShowHeader={true}
              Header={<div className="staff-search-table"></div>}
              key={'ConsultationTable'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentConsultationTables;